import { HttpClient } from "../HttpClient";

/**
 * Get Average Issuance Time
 */
export const GetAverageIssuanceTime = async ({ claimStatus, userId = null, isImpersonation = false }) => {
  try {
    let assignedDashboard = null;

    if (userId) {
      const { data: user } = await HttpClient.get(`api/users/${userId}`);
      assignedDashboard = user.assignedDashboard;
    }

    const { data } = await HttpClient.get("api/contents/AverageIssuanceTime", {
      params: {
        claimStatus,
        ...(userId && { userId }),
        ...(assignedDashboard && { assignedDashboard }),
        isImpersonation,
      },
    });

    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

// export const GetAverageIssuanceTime = async () => {
//   try {
//     const { data } = await HttpClient.get("api/contents/AverageIssuanceTime");
//     return data;
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
